import React from 'react';
import services from '../../../services';
import TitleBar from '../../../components/common/title_bar';
import { Link, withRouter } from 'react-router-dom';
import SearchFilter from '../../../components/filters/SearchFilter';
import { toast } from 'react-toastify';
import Lang from '../../../lang'
import RevenueModalForm from '../../../components/VidimaModule/Modal/CommonSideModalForm';
import * as $ from "jquery";
import TlkTable from '../../../components/tlelrik/table/tlkTable';
import RecentInvoiceGenPopUp from './RecentInvoiceGenPopUp'
import RightPopModalForm from '../../../components/common/RightPopModalForm';
import RevenueEntityAction from '../../../components/common/RevenueEntityAction';
import TransferirModal from './TransferirModal'
import RotulosTables from './RotulosTables';
import { Button } from '@progress/kendo-react-buttons'
import ImagePreviewPopUp from '../../../components/common/parcel_delete_modal';
var moment = require('moment')
const dateFormat = "YYYY-MM-DD";

const servicesMenuArray = [
    { "main": "Tx. Aguardente", name: "Taxas referentes à comercialização de aguardente" },
    { "main": "Tx. Vinhos", name: "Taxas referentes à comercialização de vinhos no mercado nacional, estrangeiro e vinho modificado" },
    { "main": "Selos e Cápsulas", name: "Compras de Selos e/ou Cápsulas" },
    { "main": "req. serviços", name: "Requisições de serviço" },
    { "main": "fiscalização", name: "Custos de fiscalização" },
    { "main": "medidas de intervenção", name: "Taxas referentes às Medidas de Intervenção" },
    { "main": "artigos diversos", name: "Artigos diversos", api: "" },
    { "main": "juros de mora", name: "Juros de Mora" },
    { "main": "observações", name: "Observações diversas" },
]

let defaultRequest = {
    "Filters": null,
    "SortBy": "",
    "IsSortTypeDESC": true,
    "IsPagination": false,
    "Page": 2,
    "PageSize": 2
};

const PendingProcessPopUp = (props) => {
    const processAction = () => {
        $('#process-pending').trigger('click')
        props.history.push({
            pathname : "/n_d_processo",
            search : '?from='+window.location.pathname.substr(1)+'&evaluator=1&id='+props.row.id+'&estado='+props.row.estado+"&tdp=" + props.row.descricaos
        })
    }

    const handleConsultor = () => {
        $('#process-pending').trigger('click')
        let paramoption = {
            name: 'Pendentes',
            url: 'rotulos',
            tableName: "RotulosPendentes"
        }
        props.history.push({
            pathname : "/rotulos",
            state:{paramoption:paramoption}
        })
    }

    return (
          <div className="modal-content">
            <div className="modal-header">
                <h4 className="modal-title pl-0">Atenção</h4>
            </div>
            <div className="modal-body w-100 pt-0">
                <p className="pb-4">
                    Existem {props.count} processsos por avaliar na sua área de avaliações pendentes.
                </p>
                <div className="row">
                    <div className="col-md-12 text-right">
                        {
                            props.count > 0 &&
                            <Button className="mr-2" onClick={()=>handleConsultor()}>Consultar</Button>
                        }
                        <Button primary={true} onClick={()=>processAction()} className="btn-ivdp-primary">Continuar</Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

class ReceitasEmCobranca extends React.Component {

    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filter: this.props.linkData.filters,
            popUpForm: '',
            popUpForm2: null,
            processPopUpForm:null,
            imagePopUp:"",
            entity_details: {
                busEntidade: {},
                currentEntityBalance: 0,
                billingAddress: []
            },
            billing_address: null,
            applyedfilter: {
              //  entity_id: this.props.parsed.entity_id
            },
            checkedInvoice: [],
            general_balance_row: "",
            date:new Date(),
            recentGenInvoicePopUp:''
        }
    }

   /* Esta é a primeira etapa após o construxctor para carregar este componente  */

 componentDidMount() {
        this.createState();
        $(window).scrollTop(0);
        // this.getCurrentGeneralAccount();
    }

    /* Esta função irá chamar automaticamente quando o estado da página mudar */

    componentDidUpdate(preProp) {
        if (preProp.date !== this.props.date) {
            $(window).scrollTop(0);
            this.createState();
        }
    }

    /* Para criar o estado básico da página no carregamento */

    createState = () => {
        this.setState({
            entity_details: {
            },
            applyedfilter: {},
            filters: this.props.linkData.filters
        });

        // if (this.props.parsed.entity_id) {
        //     let applyedfilter = {...this.state.applyedfilter};
        //     applyedfilter.entity_id = this.props.parsed.entity_id
        //     this.setState({
        //         applyedfilter
        //     },()=>this.getEntityDetails(this.props.parsed.entity_id));
        // }
        // if(this.props.parsed.invoice_id){
        //     let applyedfilter = {...this.state.applyedfilter};
        //     applyedfilter.invoice_id = ""+this.props.parsed.invoice_id
        //     this.setState({
        //         applyedfilter
        //     });
        // }
    }
    /* Para obter dados filtrados do componente de filtro personalizado  */

    handleFilter = (data) => {
        // this.setState({
        //     filterData: data
        // }, () => this.createTabel())
    }
    /*  Para obter a chave de filtros dos filtros personalizados para recuperar a API com base nisso */

    getFilters = (customfilters) => {
        let applyedfilter = { ...customfilters.filterCheckbox, ...customfilters.filters }
        delete applyedfilter.entity;
        applyedfilter.local = window.localStorage.getItem('Local');
        console.log("filter", applyedfilter);
        this.setState({
            applyedfilter,
            date:new Date()
        });
    }

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = async (action, row) => {
        console.log("action and row 333444555",action, row)
        let numeroAvalcao;
        if(row.evaluationStatus==="pending"){
            numeroAvalcao=0;
        }
        else if(row.evaluationStatus==="under_review1" || row.evaluationStatus==="review1_pending_2"){
            numeroAvalcao=1;
        }
        else{
            numeroAvalcao=2;
        }
        let topBarMenu = this.props.topBarMenuOption
        // if(row.estado==='Sob Análise'){
        //     toast.error('este rótulo está em análise')
        //     return;
        // }
           
        if (action === 'processOrder1') {
            this.checkUserPendingProcess(row);
            return;
        }
        // else if (action === 'processOrder2') {
        //     this.props.history.push({
        //         pathname : "/n_d_processo",
        //         search: "?evaluator=2&id="+row.idAvaliacao
        //     })
        //     return
        // }else if (action === 'processOrder') {
        //     this.props.history.push({
        //         pathname : "/n_d_processo",
        //         search: "?evaluator=0&id="+row.idAvaliacao
        //     })
        //     return
        // }
        else if (action === 'transferOrder') {
            //------------------------------------- transfer check api here----------------
            //console.log("row 2445", row)
            let isTransfer = await services.apiCall.requestApi('/SIVDP/getCheckTransfer',{ id: row.id},'post')
            console.log("transfer 2233", isTransfer)
            if(isTransfer === "Sim" || isTransfer === true) {
                console.log("if true executed 2233")
                this.props.history.push({
                    pathname : "/n_d_processo",
                    search: '?from='+window.location.pathname.substr(1)+"&view=transfer&id="+row.id +'&estado='+row.estado+"&tdp=" + row.descricaos+"&processo="+row["Nº Processo"] + "&marca="+ row.Marca
                })
            }
            else {
                console.log("else executed 2233")
                toast.error("A solicitação de etiqueta selecionada não tem uma transferência associada")
            }
            return
        }else if(action === 'processOrder2') {
            
            this.props.history.push({
                pathname : "/n_d_processo",
                search: '?from='+window.location.pathname.substr(1)+"&evaluator="+numeroAvalcao+'&estado='+row.estado+"&id="+row.id+"&tdp=" + row.descricaos+"&processo="+row["Nº Processo"] + "&marca="+ row.Marca
            })
            return
        }else if(action === 'ImagePreview'){
            let imagePopUp = (
                <ImagePreviewPopUp popupFor="imagePreview" id={row.id} date={new Date()} />
            )
            this.setState({imagePopUp})
        }
        else if(action==="aprovados"){

            this.props.history.push({pathname : "/n_d_processo",search:'?from='+window.location.pathname.substr(1)+"&view=processo&id="+row.id+'&estado='+row.estado+"&tdp=" + row.Descrição+"&processo="+row["Nº Processo"]+ "&marca="+ row.Marca + "&idRegistoProduto="+ row.idRegistoProdutoEncrypt})    
        }
        else{
            this.props.history.push({pathname : "/n_d_processo",search:'?from='+window.location.pathname.substr(1)+"&view=processo&id="+row.detalheURLID+"&correlativa="+row.detalheURLCorrelativa+"&codEstado="+row.detalheURLCodEstado +"&idEntidade="+row.detalheURLIDEntidade + "&idRegistoProduto="+ row.idRegistoProdutoEncrypt})    
            return;
        }
    }

    checkUserPendingProcess = async (row) => {
        let res = await services.apiCall.requestApi('/SIVDP/pending_evelution_count_list',{},'get')
        // let res = Math.random().toFixed(1)
        if(res == 0){
            this.setState({processPopUpForm : null},()=>{
                this.props.history.push({
                    pathname : "/n_d_processo",
                    search : '?from='+window.location.pathname.substr(1)+'&evaluator=1&id='+row.id+'&estado='+row.estado+"&tdp=" + row.descricaos+"&processo="+row["Nº Processo"] + "&marca="+ row.Marca
                })
            })
        }
        else{
            document.getElementById('processPopUp').click();
            let processPopUpForm = (
                <PendingProcessPopUp {...this.props} row={row} count={res} />
            )
            this.setState({processPopUpForm})
        }
    }

/*  Para renderizar o conteúdo html da página   */

render() {
    console.log("Tablename",this.props.linkData.tableName);
        return (
            <div className="inner-container">
                <a className="hidden" id="processPopUp" data-toggle="modal" data-target="#process-pending"></a>
                <div className="outer-space">
                    <TitleBar
                        path={this.props.linkData.TitleBarpath}
                        title={this.props.linkData.TitleBartitle}
                        logo={"rotulos"}
                        prevPageName={this.props.linkData.prevPageName}
                        prevPageLink={this.props.linkData.prevPageLink}
                        linkData={this.props.linkData}
                        noOption={true}
                        changeOption={(mainIndex, subIndex) => this.props.changeOption(mainIndex, subIndex)} optionMenuArray={this.props.optionMenuArray} />
                    {/* {
                        this.props.linkData.filters && Object.keys(this.props.linkData.filters).length > 0 &&
                        <SearchFilter showEntity={true}
                            filterFor="Rotulo"
                            filters={this.props.linkData.filters}
                            handleFilter={(data) => this.handleFilter(data)}
                            getFilter={(data) => this.getFilters(data)}
                            data={this.state.data} 
                            searchplaceholder={"Pesquisa por número de processo"}
                        />
                    } */}
                    {
                        <RotulosTables
                            date={this.state.date}
                            tableName={this.props.linkData.tableName}
                            applyedfilter={this.state.applyedfilter}
                            ActionPerform={(action, row) => this.ActionPerform(action, row)}
                            title={this.props.linkData.TitleBartitle}
                        />
                    }
                </div>
                {
                    <div className="modal fade" id="process-pending">
                    <div className="modal-dialog modal-dialog-centered">
                        {this.state.processPopUpForm}
                    </div>
                    </div>
                }
                {
                    <div className="modal fade" id="popup-image-preview">
                    <div className="modal-dialog modal-dialog-centered">
                        {this.state.imagePopUp}
                    </div>
                    </div>
                }
            </div>
        )
    }
}


export default withRouter(ReceitasEmCobranca);